<template>
  <div class="actions-container">
    <div class="logo-container p-16">
      <button
        class="action-logo"
        :class="localParticipant.video ? 'active' : 'noactive'"
        :disabled="cameraOrMicBlocked"
        @click="$store.dispatch('localVideo', !localParticipant.video)"
      >
        <img
          :src="
            require('../../assets/img/action-' +
              (localParticipant.video ? '1' : 'start') +
              '.svg')
          "
          style="width: 20px; height: 20px"
        />
      </button>
      <div class="action-name">
        {{ localParticipant.video ? "Stop" : "Start" }}
      </div>
    </div>
    <div class="logo-container p-16">
      <div
        class="action-logo"
        :class="localParticipant.audio ? 'noactive' : 'active'"
        :disabled="cameraOrMicBlocked"
        @click="$store.dispatch('localAudio', !localParticipant.audio)"
      >
        <img
          :src="
            require('../../assets/img/action-' +
              (localParticipant.audio ? '2' : 'unmute') +
              '.svg')
          "
          style="width: 20px; height: 20px"
        />
      </div>
      <div class="action-name">
        {{ localParticipant.audio ? "Mute" : "Unmute" }}
      </div>
    </div>
    <div
      @click="onBlurClick"
      class="logo-container p-16"
      v-if="localParticipant.video"
    >
      <div
        :class="{
          'action-logo': true,
          noactive: !blurredBackground,
          active: blurredBackground,
        }"
      >
        <img
          :src="require('../../assets/img/action-blur.svg')"
          style="width: 20px; height: 20px"
        />
      </div>
      <div class="action-name">Blur</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Actions",
  data() {
    return {};
  },
  mounted() {
    window.__controls__ = this;
  },
  computed: {
    isPublic() {
      return this.$store.state.meeting.meeting.isPublic;
    },
    cameraOrMicBlocked() {
      return this.$store.state.meeting.cameraOrMicBlocked;
    },
    localParticipant() {
      return this.$store.getters.localParticipant;
    },
    participants() {
      return this.$store.state.meeting.participants;
    },
    blurredBackground() {
      return this.$store.state.meeting.blurredBackground;
    },
  },
  methods: {
    onBlurClick() {
      if (this.blurredBackground) {
        this.$store.dispatch("stopBlurBackground");
      } else {
        this.$store.dispatch("blurBackground");
      }
    },
    cameraOn() {
      this.$store.dispatch("cameraOn");
    },

    cameraOff() {
      this.$store.dispatch("cameraOff");
    },

    micOn() {
      this.$store.dispatch("micOn");
    },

    micOff() {
      this.$store.dispatch("micOff");
    },
  },
};
</script>

<style scoped>
.actions-container {
  display: inline-flex;
  justify-content: center;
  text-align: center;
  width: 100%;
}

.action-logo {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 16px;
  opacity: 1;
  cursor: pointer;
  width: 48px;
  height: 48px;
}

.action-logo:hover {
  background-color: #fc5a12;
}

.p-16 {
  padding: 0 16px;
}

.active {
  background-color: #fc5a12;
}

.noactive {
  background-color: #000;
}

.logo-container {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.action-name {
  padding-top: 16px;
  padding-bottom: 0 o !important;
  font-size: 12px;
  line-height: 16px;
  color: #000;
}
</style>
